import { Component, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: '[formGroup] group-processor, [formGroupName] group-processor',
  templateUrl: './edit-group-processor.component.html',
})
export class EditGroupProcessorComponent implements OnInit {
  providerGroupProcessorsForm: UntypedFormGroup;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.providerGroupProcessorsForm = this.controlContainer
      .control as UntypedFormGroup;
  }
}
